var React = require('react');

function Divider2 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0)","key":0},React.createElement("path",{"d":"M85.5 1079.95C43.7072 966.929 19.9593 852.301 14.5 737.24C8 600.336 29.872 512.409 41.5 424.739C59.279 290.7 60.81 99.3082 -16.5 -142.448H85.5L85.5 1079.95Z","fill":"#f9f9f9"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0"},React.createElement("rect",{"width":"1000","height":"60","fill":"#f9f9f9","transform":"translate(0 1000) rotate(-90)"})))]);
}

Divider2.defaultProps = {"width":"60","height":"1000","viewBox":"0 0 60 1000","fill":"#f9f9f9","preserveAspectRatio":"none"};

module.exports = Divider2;

Divider2.default = Divider2;
